import React from "react";
import { cuFormat } from "../../../components/coreUiTable/Format";
import Table from "../../../components/coreUiTable/Table";
import { colHeaders, addGaps, customFn } from "../utils/dataForTables";
import ProjectedBar from "../../../components/projectedBar/projectedBar";
import DataDisplay from "../../../components/dataDisplay/dataDisplay";
import { useSelector } from "react-redux";

export const IndicatorsTable = ({
  chartData: { data = [], columns = [], links = [], progress_data = [] } = {}
}) => {
  let scopedSlots = {};
  const isUserQa = useSelector((state) => state.commonReducer.commonProps.qa);
  if (data.length > 0) {
    addGaps(data, links);
    scopedSlots = {
      ...cuFormat({
        headers: colHeaders,
        columns,
        links,
        customFn: (header, value, rawValue) => customFn(header, value, rawValue)
      })
    };
  }

  return (
    <>
      <div className="dailyPulse__section ">
        <p className="title">Key performance goals progress</p>
        <div className="dailyPulse__legends">
          <div className="dailyPulse__legend">
            <div className="dailyPulse__legend__rect" />
            <div className="dailyPulse__legend__title">MTD Goal</div>
          </div>
          <div className="dailyPulse__legend">
            <div className="dailyPulse__legend__rect" />
            <div className="dailyPulse__legend__title">MTD Actual</div>
          </div>
        </div>
        <div className="dailyPulse__bars">
          {progress_data.map((progress) => {
            let { goal, mtd, name, tooltip, value } = progress;
            return (
              <div key={name} className="dailyPulse__bar">
                <p className="dailyPulse__bar__title">{name}</p>
                <p className="dailyPulse__bar__percent">
                  <DataDisplay
                    value={value}
                    type="percentage"
                    disableAnimation={isUserQa}
                    showDecimal
                    toFixedValue={1}
                    size={28}
                  />
                </p>
                <div className="dailyPulse__bar__content">
                  <ProjectedBar
                    isStacked
                    isAnimated={false}
                    value={goal}
                    projectedValue={mtd}
                    tooltip={tooltip}
                    hideMinus
                    fillWidth
                    isPercent={false}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="dailyPulse__section">
        <p className="title">Key performance indicators</p>
        <Table
          table={{ data, colHeaders }}
          pagination={false}
          tableFilter={false}
          tableWrapperId="dailyPulseTable"
          scopedSlots={scopedSlots}
        />
      </div>
    </>
  );
};
